export default __webpack_public_path__ + "static/media/slime.c84fea6e.png";